import React from 'react';

interface Props {
  children: React.ReactNode;
}

const PlaceholderText = ({children}: Props) => (
  <div className="college-earnings-empty-placeholder">
    <p className="college-earnings-empty-placeholder-description">{children}</p>
  </div>
);

export default PlaceholderText;
